import { useTranslate } from '@i18n';
import { Box, Text } from '@ui';

export const VideoError = () => {
    const t = useTranslate();
    return (
        <Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center">
            <Text>{t('error_message.failed_video_load')}</Text>
        </Box>
    );
};
